import React from 'react';
import * as MyCells from '../../../utils/Cells';
import * as util from '../../../utils/EnumMapping';
import ActionMenu from '../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';
import { MultiSelectFilterFn } from '../../common/filters/Filters';
import MultiSelectColumnFilter from '../../common/filters/MultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Számla/Előírás',
            id: 'payable',
            headerClassName: 'mainheader divided',
            columns: [
                /*{
                    Header: 'Státusz',
                    accessor: 'payable.stateLabel',
                    id: 'payableStateLabel',
                    show: true,
                    className: 'status',
                    Filter: StateMultiSelectColumnFilter,
                    filter: StateMultiSelectFilterFn,
                    Cell: props => <StatusCell row={props.row.original} />,
                },*/
                {
                    Header: 'Sorszám',
                    accessor: 'payable.publicId',
                    id: 'payablePublicId',
                    show: true,
                    className: 'idColumn center',
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Dátum',
                    accessor: 'payable.date',
                    id: 'date',
                    show: true,
                    className: 'dateColumn',
                    headerClassName: 'subheader',
                    Filter: DateRangeColumnFilter,
                    filter: DateRangeColumnFilterFn,
                    Cell: props => <MyCells.DateCell value={props.value} />,
                },
                {
                    Header: 'Típus',
                    accessor: 'payable.balanceTypeLabel',
                    id: 'balanceTypeLaber',
                    show: true,
                    headerClassName: 'subheader',
                    Filter: MultiSelectColumnFilter,
                    filter: MultiSelectFilterFn,
                },
                {
                    Header: 'Megnevezés',
                    accessor: 'payable.comment',
                    id: 'payableComment',
                    show: true,
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Partner',
                    accessor: 'payable.partnerName',
                    id: 'payablePartner',
                    show: true,
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Összeg',
                    accessor: 'payable.amount',
                    id: 'payableAmount',
                    show: true,
                    className: 'right amountColumn',
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                    Cell: props => <MyCells.NumberCell value={props.value} />,
                },
                {
                    Header: 'Fizetési mód',
                    accessor: 'payable.paymentMethodLabel',
                    id: 'payablePaymentMethodLabel',
                    show: true,
                    className: 'iconColumn divided',
                    headerClassName: 'subheader divided',
                    Filter: MultiSelectColumnFilter,
                    filter: MultiSelectFilterFn,
                    Cell: props => <MyCells.IconCell label={props.value} list={util.paymentMethods} />,
                },
            ],
        },
        {
            Header: 'Link',
            id: 'common',
            headerClassName: 'mainheader linked divided',
            columns: [
                {
                    Header: 'Módosítás Dátuma',
                    accessor: 'date',
                    id: 'linkDate',
                    show: true,
                    className: 'linked dateColumn value',
                    headerClassName: 'subheader linked',
                    Filter: DateRangeColumnFilter,
                    filter: DateRangeColumnFilterFn,
                    Cell: props => <MyCells.DateCell value={props.value} />,
                },
                {
                    Header: 'Linkelt Összeg',
                    accessor: 'amount',
                    id: 'amount',
                    show: true,
                    className: 'linked value right amountColumn divided',
                    headerClassName: 'subheader linked divided',
                    Filter: TextColumnFilter,
                    Cell: props => <MyCells.NumberCell value={props.value} />,
                },
            ]
        },
        {
            Header: 'Tranzakció',
            id: 'transaction',
            headerClassName: 'mainheader',
            columns: [
                {
                    Header: 'Sorszám',
                    accessor: 'transaction.publicId',
                    id: 'transactionPublicId',
                    show: true,
                    className: 'idColumn center',
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Számlakivonat Sorszám',
                    accessor: 'transaction.transactionId',
                    id: 'transactionId',
                    show: true,
                    className: 'idColumn center',
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Dátum',
                    accessor: 'transaction.date',
                    id: 'transactionDate',
                    show: true,
                    className: 'dateColumn',
                    headerClassName: 'subheader',
                    Filter: DateRangeColumnFilter,
                    filter: DateRangeColumnFilterFn,
                    Cell: props => <MyCells.DateCell value={props.value} />,
                },
                {
                    Header: 'Megjegyzés',
                    accessor: 'transaction.comment',
                    id: 'transactionComment',
                    headerClassName: 'subheader',
                    show: true,
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Ellenoldal Név',
                    accessor: 'transaction.contraName',
                    id: 'transactionContraName',
                    headerClassName: 'subheader',
                    show: true,
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Ellenoldal Számlaszám',
                    accessor: 'transaction.contraBankAccountNumber',
                    id: 'transactionContraBankAccountNumber',
                    headerClassName: 'subheader',
                    show: true,
                    Filter: TextColumnFilter,
                },
                {
                    Header: 'Összeg',
                    accessor: 'transaction.amount',
                    id: 'transactionAmount',
                    show: true,
                    className: 'right amountColumn',
                    headerClassName: 'subheader',
                    Filter: TextColumnFilter,
                    Cell: props => <MyCells.NumberCell value={props.value} />,
                },

            ]
        },
        {
            Header: () => null,
            id: 'action',
            headerClassName: 'mainheader',
            columns: [
                {
                    id: 'menu',
                    show: true,
                    headerClassName: 'subheader actions',
                    className: 'actions',
                    Header: () => null, // No header
                    Cell: value => <ActionMenu row={value.row.original} tabletype={'link'} refresh={refresh} />,
                },
            ]
        },
    ]
}